import { render, staticRenderFns } from "./SearchDocumentsGroups.vue?vue&type=template&id=1afb46a1&"
import script from "./SearchDocumentsGroups.vue?vue&type=script&lang=js&"
export * from "./SearchDocumentsGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports